let key = {};
let IPFS_IMG = "https://ipfs.io/ipfs/";
let Back_Url = "";
var FRONT_URL = "";
var ImG = "";
var EnvName = "sales";
var networkTransUrl = ''

var Front_market_Url = ''

if (EnvName === "local") {
  Back_Url = "http://localhost:3030/v1/admin";
  Front_market_Url = "http://localhost:3000/naiftyadmin";
  ImG = "http://localhost:3030";
  var chainId = 84532;
  var ETHCHAIN = 84532
  var BNBCHAIN = 97
  var chainlist = [97, 84532]
  var ETHTRADE = '0x5b6AaF50abD17EA1faE897c487B71CDf75d90769'.toLowerCase()
  var BNBTRADE = "0x419Ee320F99287A93B4362C4A45679E30736d05a".toLowerCase()
  var ETHprovider = "https://base-sepolia.infura.io/v3/8bdcb041261546d0b6b11c4e3876c2f4";
  var Back_Url_Token = "http://localhost:3030/v1";
  var COIN_NAME = "ETH"
  networkTransUrl = "https://sepolia.etherscan.io/tx/"
  var tradeAddress = "0x895b66701bcdd1618932c83204Cd044C91265d99".toLowerCase()  // created on 27/05/25
  var stakeAddress = "0x743B3FA72e4e242B7efC8714ecd82167891F5001".toLowerCase()  //  created on 27/05/25

}

if (EnvName === "sales") {
  Back_Url = "https://homecubesbdbackend.maticz.in/v1/admin";
  Front_market_Url = "http://localhost:3000/naiftyadmin";
  ImG = "https://homecubesbdbackend.maticz.in";
  var chainId = 84532;
  var ETHCHAIN = 84532
  var BNBCHAIN = 97
  var chainlist = [97, 84532]
  var ETHTRADE = '0x5b6AaF50abD17EA1faE897c487B71CDf75d90769'.toLowerCase()
  var BNBTRADE = "0x419Ee320F99287A93B4362C4A45679E30736d05a".toLowerCase()
  var ETHprovider = "https://base-sepolia.infura.io/v3/8bdcb041261546d0b6b11c4e3876c2f4";
  var Back_Url_Token = "https://homecubesbdbackend.maticz.in/v1";
  var COIN_NAME = "ETH"
  networkTransUrl = "https://sepolia.etherscan.io/tx/"
  var tradeAddress = "0x895b66701bcdd1618932c83204Cd044C91265d99".toLowerCase()  // created on 27/05/25
  var stakeAddress = "0x743B3FA72e4e242B7efC8714ecd82167891F5001".toLowerCase()  //  created on 27/05/25

}

if (EnvName === "clientStage") {
  Back_Url = "https://staging-backend.homecubes.io/v1/admin";
  Front_market_Url = "https://localhost:3000/naiftyadmin";
  ImG = "https://staging-backend.homecubes.io";
  var chainId = 84532;
  var ETHCHAIN = 84532
  var BNBCHAIN = 97
  var chainlist = [97, 84532]
  var ETHTRADE = '0x5b6AaF50abD17EA1faE897c487B71CDf75d90769'.toLowerCase()
  var BNBTRADE = "0x419Ee320F99287A93B4362C4A45679E30736d05a".toLowerCase()
  var ETHprovider = "https://base-sepolia.infura.io/v3/8bdcb041261546d0b6b11c4e3876c2f4";
  var Back_Url_Token = "https://staging-backend.homecubes.io/v1";
  var COIN_NAME = "BASE"
  networkTransUrl = "https://sepolia.basescan.org/tx/"
  var tradeAddress = "0x895b66701bcdd1618932c83204Cd044C91265d99".toLowerCase()  // created on 27/05/25
  var stakeAddress = "0x743B3FA72e4e242B7efC8714ecd82167891F5001".toLowerCase()  //  created on 27/05/25

}

if (EnvName === "production") {
  Back_Url = "https://api.homecubes.io/v1/admin";
  Front_market_Url = "https://app.homecubes.io/";
  ImG = "https://api.homecubes.io";
  var tradeAddress = "0x06634158F0a6fdb7686b67d128d5b8d498349cD9".toLowerCase()  // audit bsc testnet
  var chainId = 11155111;
  var ETHCHAIN = 11155111
  var BNBCHAIN = 97
  var chainlist = [97, 11155111]
  var ETHTRADE = '0x5b6AaF50abD17EA1faE897c487B71CDf75d90769'.toLowerCase()
  var ETHprovider = "https://eth-sepolia.g.alchemy.com/v2/demo";
  var Back_Url_Token = "https://api.homecubes.io/v1";
  networkTransUrl = "https://sepolia.etherscan.io/tx/"
  var COIN_NAME = "BNB"
  var stakeAddress = "0x966D215D56b06E3469Df0D9fD80A5cB78f9A1EAA"
}

key = {
  AdminAPI: `${Back_Url}`,
  Back_Url: `${Back_Url_Token}`,
  chainId: chainId,
  ETHprovider: ETHprovider,
  ETHCHAIN: ETHCHAIN,
  BNBCHAIN: BNBCHAIN,
  chainlist: chainlist,
  ENVname: EnvName,
  networkTransUrl: networkTransUrl,
  tradeAddress: tradeAddress,
  ImG: ImG,
  IPFS_IMG: IPFS_IMG,
  ETHTRADE: ETHTRADE,
  BNBTRADE: BNBTRADE,
  EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  AdminAddress: "0x025c1667471685c323808647299e5DbF9d6AdcC9".toLowerCase(),
  noimg: require("../assets/images/No_image.webp"),
  FRONT_URL: FRONT_URL,
  Front_market_Url: Front_market_Url,
  KEY: 'MNBVCZX1234)(*',
  NumDigitOnly: /[^0-9\.]/g,
  COIN_NAME: COIN_NAME,
  stakeAddress: stakeAddress,
  DEADADDRESS: '0x000000000000000000000000000000000000dEaD'.toLowerCase()
};

export default key;
